import { render, staticRenderFns } from "./yinyang_total.vue?vue&type=template&id=0b76e44f&scoped=true&"
import script from "./yinyang_total.vue?vue&type=script&lang=js&"
export * from "./yinyang_total.vue?vue&type=script&lang=js&"
import style0 from "./yinyang_total.vue?vue&type=style&index=0&id=0b76e44f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b76e44f",
  null
  
)

export default component.exports